import http from '@/utils/ajax'
import { BLKPARAM_INIT_LOADING, BLKPARAM_INIT_SUCCESS, BLKPARAM_INIT_FAIL } from '@/store/types'
import { extractMenu, extractMessages } from '@/utils/extract'

const state = {
  init: 0,
  initErr: [],
  menu: {}
}

const getters = {

}

const mutations = {
  [BLKPARAM_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [BLKPARAM_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [BLKPARAM_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  }
}

const actions = {
  async blkParamManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.blkParamManagement
    commit(BLKPARAM_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(BLKPARAM_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(BLKPARAM_INIT_FAIL, extractMessages(error))
    }
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
